<template>
    <svg height="12pt" viewBox="0 0 512 512" width="12pt" xmlns="http://www.w3.org/2000/svg">
        <path
            d="m452 120h-30v-60h-30v-60h-123.027344l-20 30h-128.972656v60h-30v60h-30v40.457031l-60 90v231.542969h512v-231.542969l-60-90zm-302-60h115.027344l20-30h76.972656v30h-63.027344l-20 30h-128.972656zm-30 60h175.027344l20-30h76.972656v30h-63.027344l-20 30h-188.972656zm-30 60h235.027344l20-30h76.972656v120h-105.8125l-10 30h-100.375l-10-30h-105.8125zm-30 64.542969v25.457031h-16.972656zm422 237.457031h-452v-182h144.1875l10 30h143.625l10-30h144.1875zm-13.027344-212h-16.972656v-25.457031zm0 0"
        />
        <path d="m180 360h152v30h-152zm0 0" />
    </svg>
</template>

<script>
export default {
    name: "ArchiveIcon",
};
</script>

<style scoped></style>
